import type { ModelBuilder } from '@/reducers/model-builder'

export enum MunicipalStatePreference {
  National = 'national',
  StatePreferred = 'state-preferred',
  StateFocused = 'state-focused',
}

export function getFieldsToResetOnPreferenceChange(
  selectedPreference: MunicipalStatePreference,
): Array<keyof ModelBuilder> {
  const fields: Array<keyof ModelBuilder> = ['excludeMunicipalStates']

  if (
    [
      MunicipalStatePreference.National,
      MunicipalStatePreference.StateFocused,
    ].includes(selectedPreference)
  ) {
    fields.push(
      'municipalState',
      'stateMinWeight',
      'stateTargetWeight',
      'stateMaxWeight',
      'stateBuffer',
    )
  }

  return fields
}
